import React from 'react';
import ControlPlaneLayout from './ControlPlaneLayout';

const AgentsPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Agents Page"
      title="Requester agents"
      description="Configure spend caps, approval thresholds, and the request types your agents can post automatically."
    />
  );
};

export default AgentsPage;
